import { CurrencyCode } from './CurrencyProvider';

// Minimal prisformatterare
// amount ska vara i rätt valuta (ej SEK)
export function formatPrice(amount: number, currency: CurrencyCode): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount);
}
